import { toggle } from 'slidetoggle';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock/lib/bodyScrollLock.es6';

function mobileMenuActivate() {
    const mediaQuery = '(max-width: 768px)';
    const mediaQueryList = window.matchMedia(mediaQuery);

    const menuToggle = document.querySelector(".menu-toggle");
    const mobileNav = document.getElementById("mobile-nav");


    mediaQueryList.addEventListener('change', event => {
        if (event.matches) { // < 768px
            menuToggle.classList.add("active")
            mobileNav.classList.add("active")
        } else { // > 768px
            menuToggle.classList.remove("active");
            mobileNav.classList.remove("active");
        }
    });
}

// sets a custom property for the height of the viewport accounting for the browser address bar
function setVh() {
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    // We listen to the resize event
    window.addEventListener('resize', () => {
        // We execute the same script as before
        vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    });
}

// Mobile menu functionality
function clickBurger() {
    const headerWrapper = document.getElementById("masthead");
    const headerNav = document.querySelector(".header__nav");
    const targetButton = document.querySelector(".menu-toggle");
    const menu = document.getElementById("mobile-nav");
    const menuLinks = menu.querySelectorAll('a')
    // const innerMenu = document.querySelector('.mobileMenus');
    let isClosed = true;

    function burgerTime() {
        if (isClosed === true) {
            disableBodyScroll(menu);
            headerWrapper.classList.add('toggled');
            headerNav.classList.add('toggled');
            targetButton.classList.remove('active');
            targetButton.classList.add('closed-burger');
            targetButton.setAttribute('aria-expanded', 'true');
            menu.classList.remove('active', 'closed-menu');
            menu.classList.add('open-menu');
            menu.setAttribute('aria-hidden', 'false');
            menuLinks.forEach((link) => {
                link.setAttribute('tabindex', '0');
            });
            isClosed = false;
        } else {
            enableBodyScroll(menu);
            headerWrapper.classList.remove('toggled');
            headerNav.classList.remove('toggled');
            targetButton.classList.remove('closed-burger');
            targetButton.setAttribute('aria-expanded', 'false');
            menu.classList.remove('open-menu');
            menu.classList.add('closed-menu');
            menu.setAttribute('aria-hidden', 'true');
            menuLinks.forEach((link) => {
                link.setAttribute('tabindex', -1);
            });
            setTimeout(() => {
                targetButton.classList.add('active');
            }, 200);
            setTimeout(() => {
                menu.classList.add('active');
            }, 300);
            isClosed = true;
        }
    }

    document.addEventListener("keyup", (event) => {
        if (event.key === 27) { // escape key maps to key `27`
            enableBodyScroll(menu);
            headerWrapper.classList.remove('toggled');
            headerNav.classList.remove('toggled');
            targetButton.classList.remove('closed-burger');
            targetButton.classList.add('open-burger');
            targetButton.setAttribute('aria-expanded', 'false');
            menu.classList.remove('open-menu');
            menu.classList.add('closed-menu');
            menu.setAttribute('aria-hidden', 'true');
            menu.querySelectorAll('a').setAttribute('tabindex', '-1');
            isClosed = true;
        }
    });

    targetButton.addEventListener("click", burgerTime);

    // Close menu when clicking anchor links
    menuLinks.forEach((link) => {
        link.addEventListener('click', (event) => {
            const href = link.getAttribute('href');
            if (href && href.startsWith('#')) {
                burgerTime();
            }
        });
    });
}

// adds sub menu functionality to mobile menu
function mobileMenuSub() {

    const subMenu = Array.from(document.querySelectorAll('#mobile-menu > .menu-item-has-children > .sub-menu'));
    const menuItem = Array.from(document.querySelectorAll('#mobile-menu > .menu-item-has-children > a'));


    // set display none on sub menu
    subMenu.forEach((item) => {
        item.style.display = 'none'; // eslint-disable-line no-param-reassign
    });

    // add elemnt after each menu item
    menuItem.forEach((item) => {
        const indicator = document.createElement('span');
        indicator.classList.add('headerNavMobile__itemMarker');
        indicator.setAttribute('aria-hidden', 'true');

        item.appendChild(indicator);

        item.addEventListener('click', (event) => {
            event.preventDefault();
            const target = event.target;
            const targetSibling = target.nextElementSibling;
            target.classList.toggle('open');

            toggle(targetSibling, {
                miliseconds: 260,
                transitionFunction: 'ease-in',
                elementDisplayStyle: 'block',
            });
        });
    });

}



/**
 * Function to run when this module is called from site.js
 */
const init = () => {
    mobileMenuActivate();
    setVh();
    clickBurger();
    mobileMenuSub();
};

export default init;
